import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Contrato, Licitacao, Page, Proponente, Proposta } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContratoService extends BaseResourceService<Contrato> {

  constructor(
    protected injector: Injector
  ) {
    super(`contratos`, injector);
  }

  public obterPorNumero(numero: number, orgaoId: number): Observable<Contrato> {
    return this.http.get<Contrato>(
      `${this.login.cidade.id}/${this.api}/filtrar?relations=favorecido&numero$like=${numero}%&orgao_id=${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public proximoNumero(ano: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/proximo-numero/${ano}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorLicitacao(id: number, orgaoId: number): Observable<Page> {
    let uri = `relations=favorecido,itens&licitacao.id=${id}&orgao_id=${orgaoId}`;
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar?${uri}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterContratosPendentesLicitacao(entidade: Licitacao): Proponente[] {
    const listaPendentes = [];

    if (entidade?.proponentes?.length > 0) {
      entidade.proponentes.forEach(proponente => {
        if (!entidade.contratos?.find(c => c.favorecido.id === proponente.favorecido.id)) {
          const vencedoras: Proposta[] = Object.assign([], proponente.propostas.filter(p => p.situacao === 'VENCEDOR'));
          if (vencedoras?.length > 0) {
            const pendente = Object.assign({}, proponente);
            pendente.propostas = vencedoras;
            pendente.licitacao = Object.assign({}, entidade);
            delete pendente.licitacao.proponentes;
            delete pendente.licitacao.itens;
            listaPendentes.push(pendente);
          }
        }
      })
    }

    return listaPendentes;
  }
}
